





















import { HsabAccountNametag } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {}
})
export default class HsabAccountListItem extends Vue {
  @Prop({ required: true })
  account: HsabAccountNametag;

  @Prop({ required: true })
  employerName: string;

  hsabAccountsStore = useHsabAccountsStore();

  get formattedAccountBalance () {
    return formatCurrency(this.account.accountBalance);
  }

  onClick () {
    this.hsabAccountsStore.navigateToAccountPage(this.account);
  }
}
